var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBack = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 15,
    viewBox: "0 0 16 15",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m7.7863 14.1301c-.62416.5447-1.57172.4803-2.11644-.1438l-4.799997-5.50002c-.493151-.56507-.493151-1.40753 0-1.9726l4.799997-5.5c.54472-.62416 1.49228-.688557 2.11644-.143838.62416.544718.68856 1.492278.14384 2.116438l-2.63014 3.0137h8.7c.8284 0 1.5.67157 1.5 1.5s-.6716 1.5-1.5 1.5h-8.7l2.63014 3.01372c.54472.6241.48032 1.5717-.14384 2.1164z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/back.d40f5c64c5006946df24de2ce757ee79.svg";